module.exports = __webpack_public_path__ + "8bb123ec1eaa4f0b5a1f4afab4ea8924.jpg";